import React from 'react'
import { useSelector } from 'react-redux'
import { Breadcrumb } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'
import { useViewport } from '../../../utils'
import { CardMetas } from './page-header-card-metas'

const Card = () => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const data = useSelector(state => state.organization.data)
  const {
    name,
    logo,
    background_color
  } = data

  const { isMobile, isDesktop } = useViewport()

  const size = isMobile ? '68px' : '150px'
  const backgroundSize = '60%'

  const routes = [
    {
      name: translation.NAVIGATION.home[language.name],
      route: '/',
    },
    {
      name: translation.ORGANIZATION.singular[language.name],
      route: '/organization'
    }
  ]

  return (
    <div>
      <div
        className="rounded flex text-white -mx-2 lg:-mx-4 mb-8 lg:mb-0"
        style={{boxShadow: background_color ? 'none' : '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
      >
        {/* Image */}
        <div className="w-1/4 lg:w-2/12 px-2 lg:px-4">
          <div
            className="lg:w-full h-full bg-center bg-auto bg-no-repeat rounded-full lg:mr-5"
            style={{
              width: size, height: size,
              backgroundColor: '#f9f9f9',
              backgroundImage: `url('${logo}')`,
              backgroundBlendMode: 'multiply',
              backgroundSize: backgroundSize
            }}
          />
        </div>

        {/* Content */}
        <div className="w-3/4 lg:w-10/12 px-2 lg:px-4">
          <div className="w-full">
            <Breadcrumb routes={routes}/>
            <h3 className="font-bold text-xl md:text-4xl font-primary mb-2 leading-tight">
              {name}
            </h3>
            {
              isDesktop &&
              <SystemProvider>
                <CardMetas />
              </SystemProvider>
            }
          </div>
        </div>
      </div>
      {
        !isDesktop &&
        <SystemProvider>
          <CardMetas />
        </SystemProvider>
      }
    </div>
  )
}

export { Card }
